import type {SelectItemProps} from '@smart/react-components';
import React, {useMemo} from 'react';
//import {string} from 'yup';
import type {Maybe} from '../../graphql';
import {useSchemas} from '../hooks/user-schemas';
import {AppModelContext} from './app';
import Fields from './easy-form/fields';

interface IProps {
  tag: string;
  required?: boolean;
  label?: Maybe<string>;
}

export function AmountOfCarSelect({tag, required}: IProps): JSX.Element {
  const generalSchemas = useSchemas();
  const cmsTranslations =
    React.useContext(AppModelContext).cms.formsFeatureAppFleetUi || {};

  const amountOfCarsOptions = [
    {
      label: cmsTranslations.fleet_options_05 || ``,
      value: `0-5 Cars`,
    },
    {
      label: cmsTranslations.fleet_options_510 || ``,
      value: `5-10 Cars`,
    },
    {
      label: cmsTranslations.fleet_options_1030 || ``,
      value: `10-30 Cars`,
    },
    {
      label: cmsTranslations.fleet_options_3050 || ``,
      value: `30-50 Cars`,
    },
    {
      label: cmsTranslations.fleet_options_50100 || ``,
      value: `50-100 Cars`,
    },
    {
      label: cmsTranslations.fleet_options_100500 || ``,
      value: `100-500 Cars`,
    },
    {
      label: cmsTranslations.fleet_options_500More || ``,
      value: `+500 Cars`,
    },
  ];

  const mapOfCars = amountOfCarsOptions.map((a) => {
    a.value;
    return a.value;
  });

  const carsOptions = useMemo<SelectItemProps[]>(
    () => [
      {value: ``, label: ``},
      ...amountOfCarsOptions.filter(function (option) {
        return option.label !== `-`;
      }),
    ],
    [cmsTranslations],
  );

  const schema = useMemo(
    () => generalSchemas.oneOf(mapOfCars, required),
    [carsOptions],
  );

  return (
    <Fields.Select
      label={
        tag === `totalFleetSize`
          ? cmsTranslations.fleet_companyInformation_totalFleetSize
          : cmsTranslations.fleet_companyInformation_amountOfCars
      }
      tag={tag}
      options={carsOptions}
      required={required}
      schema={tag === `totalFleetSize` ? schema : undefined}
    />
  );
}
